import { MapPin, Mail, Phone, Facebook, Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer id="contact" className="bg-foreground text-background py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Lindos Villas</h3>
            <p className="opacity-90 mb-4">
              Experience luxury and tradition in the heart of Rhodes Island
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="hover:text-primary transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 mt-1 flex-shrink-0" />
                <span className="opacity-90">
                  Lindos Village, Rhodes 85107, Greece
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <span className="opacity-90">info@lindosvillas.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="h-5 w-5 flex-shrink-0" />
                <span className="opacity-90">+30 123 456 7890</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <a href="#home" className="block opacity-90 hover:text-primary transition-colors">
                Home
              </a>
              <a href="#gallery" className="block opacity-90 hover:text-primary transition-colors">
                Gallery
              </a>
              <a href="#book" className="block opacity-90 hover:text-primary transition-colors">
                Book Now
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 pt-8 text-center opacity-75">
          <p>&copy; {new Date().getFullYear()} Lindos Villas. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
